import TabsSwitcher from './tabs_switcher';

export default TabsSwitcher;
